import { AppDispatch } from 'store/store';
import { impersonate, signIn } from 'store/user';
import { getTokenUser } from 'utils/jwt';

type HydrateSessionParams = {
  dispatch: AppDispatch;
  token?: string | null;
  impersonateId?: string;
};

export function hydrateReduxSessionState({
  dispatch,
  token,
  impersonateId,
}: HydrateSessionParams): void {
  if (impersonateId) dispatch(impersonate(impersonateId));

  if (!token) return;

  const user = getTokenUser(token);

  if (!user) return;

  dispatch(
    signIn({
      id: user.id,
      email: user.email,
      first_name: user.first_name,
      last_name: user.last_name,
      phone_number: user.phone_number,
      roles: user.roles,
      status: 'active',
    }),
  );
}
